import { Progress } from '@mantine/core';

interface ProgressHeaderProps {
  completedCount: number;
  activeCount: number;
}

export function ProgressHeader({ completedCount, activeCount }: ProgressHeaderProps) {
  const remainingCount = activeCount - completedCount;
  const percentComplete = activeCount > 0 ? Math.round((completedCount / activeCount) * 100) : 0;
  const isAllComplete = remainingCount === 0 && activeCount > 0;

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-3">
        <div>
          {isAllComplete ? (
            <span className="text-green-400 font-medium">All tasks completed!</span>
          ) : (
            <span className="text-gray-400">
              <span className="text-cyan-400 font-semibold">{remainingCount}</span>
              {' '}task{remainingCount !== 1 ? 's' : ''} remaining
            </span>
          )}
        </div>
        <div className="text-sm text-gray-500">
          {completedCount} of {activeCount} complete
        </div>
      </div>
      <Progress
        value={percentComplete}
        size="sm"
        radius="xl"
        styles={{
          root: {
            backgroundColor: 'rgba(5, 5, 10, 0.6)',
          },
          section: {
            backgroundImage: isAllComplete
              ? 'linear-gradient(90deg, #22c55e 0%, #16a34a 100%)'
              : 'linear-gradient(90deg, #00d6f5 0%, #0095ab 100%)',
            boxShadow: isAllComplete
              ? '0 0 10px rgba(34, 197, 94, 0.4)'
              : '0 0 10px rgba(0, 214, 245, 0.4)',
          },
        }}
      />
    </div>
  );
}
